import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayAreaAsset } from "../../../configuration/delay-codes/models/CatalogDelayCode";
import { DelayByShift } from "../models/DelayByShift";

type getDelaysProps = {
	startDate: Date;
	endDate: Date;
	delayAreaAssetId?: number | null;
	shift?: string;
	crew?: string;
};

export const getDelays = async ({
	startDate,
	endDate,
	delayAreaAssetId,
	shift,
	crew,
}: getDelaysProps) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "StartDate", value: startDate },
		{ name: "EndDate", value: endDate },
		{
			name: "DelayAreaAssetId",
			value: delayAreaAssetId || null,
		},
		{
			name: "Shift",
			value: (shift as string) === "all" ? null : (shift as string),
		},
		{
			name: "Crew",
			value: (crew as string) === "all" ? null : (crew as string),
		},
	];

	const resp = await apiService.callV2("[DEL].[GetDelays]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayByShift[];
	} else {
		throw new Error(resp.message || "Error fetching delays");
	}
};

export const getDelayAreas = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[DEL].[GetDelayAreas]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayAreaAsset[];
	} else {
		throw new Error(resp.message || "Error fetching delay areas");
	}
};

export const getShifts = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetShiftsAndCrews]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as String[];
	} else {
		throw new Error(resp.message || "Error fetching shifts");
	}
};

export const getCrews = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetShiftsAndCrews]", []);

	if (resp.ok) {
		return get(resp, "data.tables[1].rows", []) as String[];
	} else {
		throw new Error(resp.message || "Error fetching crews");
	}
};
